/**
 * Created by Oleg on 28.02.2020.
 */

const SubscriptionButtons = cleverapps.GridLayout.extend({
    ctor: function (options) {
        const styles = cleverapps.styles.SubscriptionButtons;
        const isIOS = connector.platform.oneOf(connector.IOS);

        const payText = isIOS ? Messages.get("SubscriptionWindow.iosMonthButton", {
            price: options.monthProduct.textPrice
        }) : options.monthProduct.getCurrentPrice();

        this.buttonPay = this.createBuyButton(options.monthProduct, options.buySubscription, cleverapps.styles.UI.Button.Images.button_blue, payText);

        const tryFreeText = Messages.get(isIOS ? "SubscriptionWindow.iosWeekButton" : "SubscriptionWindow.Free", {
            price: options.weekProduct.textPrice
        });
        this.buttonTryFree = this.createBuyButton(options.weekProduct, options.buySubscription, cleverapps.styles.UI.Button.Images.button_green, tryFreeText);

        let tryFreeTitle = Messages.get(options.weekProduct.trial.indexOf("3 day") === 0 ? "SubscriptionWindow.ThreeDaysAdditional" : "SubscriptionWindow.OneDayAdditional", {
            newline: "\n"
        });
        if (isIOS) {
            tryFreeTitle = Messages.get("SubscriptionWindow.iOSThreeDaysAdditional", {
                price: options.weekProduct.textPrice
            });
        }

        tryFreeTitle = cleverapps.UI.generateOnlyText(tryFreeTitle, cleverapps.styles.FONTS.SUBSCRIPTION_BUTTON_TITLE);
        tryFreeTitle.setDimensions(styles.buttonWidth, 0);
        tryFreeTitle.fitTo(undefined, styles.titleHeight);
        tryFreeTitle.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        let payTitle = "SubscriptionWindow.MonthlyAdditional";
        payTitle = cleverapps.UI.generateOnlyText(Messages.get(payTitle), cleverapps.styles.FONTS.SUBSCRIPTION_BUTTON_TITLE);
        payTitle.setDimensions(styles.buttonWidth, 0);
        payTitle.fitTo(undefined, styles.titleHeight);
        payTitle.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        cleverapps.paymentsLogic.onChangeStatus(this.updateButtons.bind(this), this);

        this.updateButtons();

        this._super([tryFreeTitle, payTitle, this.buttonTryFree, this.buttonPay], {
            columns: 2,
            align: {
                y: cleverapps.GridLayout.ALIGN_START
            },
            margin: styles.margin
        });
    },

    updateButtons: function () {
        if (connector.payments.isConnected()) {
            this.buttonPay.enable();
            this.buttonTryFree.enable();
        } else {
            this.buttonPay.disable();
            this.buttonTryFree.disable();
        }
    },

    createBuyButton: function (product, buyCallback, type, text) {
        const styles = cleverapps.styles.SubscriptionButtons;
        return new cleverapps.UI.Button({
            text: text || product.getCurrentPrice(),
            type,
            width: styles.buttonWidth,
            height: styles.buttonHeight,
            onClicked: function () {
                buyCallback(product);
            }
        });
    }
});

cleverapps.styles.SubscriptionButtons = {
    contentObjectsMargin: 7,
    buttonWidth: 270,
    buttonHeight: 100,
    titleHeight: 70,
    margin: {
        x: 40,
        y: 7
    }
};
